<template>
    <div id="destineAdd">
        <!-- <van-nav-bar title="预订单新增" fixed placeholder left-text="返回" left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
    </van-nav-bar> -->
        <van-form @submit="onSubmit" label-width="100px" input-align="right">
            <van-field readonly :clickable="Boolean($route.query.customerId)" :disabled="Boolean($route.query.customerId)" :value="form.phone" name="租客手机号" label="租客手机号" placeholder="点击搜索客户>" @click="item => {if(!$route.query.customerId){showCustomer = true;searchValueCustomer='';customerList=[]}}" maxlength="11" :rules="[{ required: true, message: '请填写手机号' },{ validator :validPhone, message: '请输入正确手机号' }]" />
            <van-field v-model="form.name" name="租客姓名" label="租客姓名" placeholder="点击填写" :rules="[{ required: true, message: '请填写姓名' }]" />
            <van-field readonly clickable name="house" :value="houseNow.address" label="房源" placeholder="点击搜索房源>" @click="showHouse = true;searchValueHouse='';houseList=[]" :rules="[{ required: true, message: '请选择房源' }]" />
            <div class="field">
                <van-field :border="false" name="rentType" label="预定方式">
                    <template #input>
                        <van-radio-group v-model="rentTypeNow" direction="horizontal" @change="changeRentType">
                            <van-radio v-for="item in rentTypeList" :key="item.roomNo" :name="item.roomNo" :disabled="!item.show">{{item.roomNo?item.roomNo:"整租"}}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <div v-if="isValid && !form.type" class="van-field__error-message error">请选择预定方式</div>
            </div>
            <van-field readonly clickable name="datetimePicker" :value="form.orderDate.slice(0,10)" label="入住日期" placeholder="点击选择日期>" @click="item => { showorderDate = true;startRangeDate = new Date();if(!hasDBJ){endRangeDate = date7}else{endRangeDate = new Date(2030,11,1)} }" :rules="[{ required: true, message: '请选择日期' }]" />
            <van-field v-model="form.amount" type="digit" name="定金" label="定金" placeholder="点击填写" maxlength="11" :rules="[{ required: true, message: '请填写定金' },{validator:item => {return !Boolean(item < 500 || item % 100 != 0)},message:'定金必须大于500且为100的整数倍'}]" />
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" :loading="saveLoad" :disabled="saveLoad" native-type="submit" @click="isValid = true">保存</van-button>
            </div>
        </van-form>
        <!-- 客户搜索 -->
        <transition name="van-slide-right">
            <div v-show="showCustomer" class="search">
                <form action="/">
                    <van-search v-model="searchValueCustomer" shape="round" show-action placeholder="请输入手机号搜索" @input="onSearchCustomer" @search="onSearchCustomer" @cancel="onCancel" />
                </form>
                <van-cell v-for="customer in customerList" :key="customer.id" :title="customer.name + '-' + customer.phone" icon="user-o" @click="changeCustomer(customer)"></van-cell>
                <van-loading v-if="searchLoad" size="24" />
                <div v-else-if="searchValueCustomer&&!customerList.length">暂无数据</div>
            </div>
        </transition>
        <!-- 房源搜索 -->
        <transition name="van-slide-right">
            <div v-show="showHouse" class="search">
                <form action="/">
                    <van-search v-model="searchValueHouse" shape="round" show-action placeholder="请输入房源搜索" @input="onSearchHouse" @search="onSearchHouse" @cancel="onCancel" />
                </form>
                <van-cell v-for="house in houseList" :key="house.id" :title="house.address" icon="wap-home-o" @click="changeHouse(house)"></van-cell>
                <van-loading v-if="searchLoad" size="24" />
                <div v-else-if="searchValueHouse&&!houseList.length">暂无数据</div>
            </div>
        </transition>
        <!-- 预定日期 -->
        <van-popup v-model="showorderDate" position="bottom">
            <van-datetime-picker type="date" @confirm="orderDateConfirm" @cancel="showorderDate = false" :min-date="startRangeDate" :max-date="endRangeDate" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDate, getNdaysDate } from "@/utils/index";
import { validPhone } from "@/utils/validate";
import {
    requestDesHouseList,
    requestDesCustomerList,
    requestHouseType,
    requestDestineContractAdd,
    requestCustomerDetail,
    requestHouseDetailId
} from "@/api";
export default {
    name: "destineAdd",
    data() {
        return {
            form: {
                phone: "", //电话
                name: "", //姓名
                houseId: "", //房源
                address: "", //地址
                type: "1", //预定方式
                roomId: "",
                orderDate: "", //入住日期
                amount: "" //定金
            },
            saveLoad: false,
            rentTypeNow: "",
            isValid: false,
            searchLoad: false,
            rentTypeList: [],
            showorderDate: false,
            //客户搜索
            showCustomer: false,
            searchValueCustomer: "",
            customerList: [], //搜索客户
            //房源搜索
            showHouse: false,
            houseNow: {},
            searchValueHouse: "",
            houseList: [], //搜索房源
            hasDBJ: false, //房间是否待保洁
            startRangeDate: new Date(),
            endRangeDate: new Date(2030, 11, 1),
            date7: new Date()
        };
    },
    computed: {
        ...mapState(["idTypeList", "destineList", "payList", "contractList"])
    },
    created() {
        if (this.$route.query.customerId) {
            this.getCustomerDetail();
        }
        if (this.$route.query.houseId) {
            this.getHouseDetail();
        }
    },
    mounted() {
        this.date7 = new Date(getNdaysDate(formatDate(new Date()), 7));
    },
    methods: {
        //客户下定
        getCustomerDetail() {
            requestCustomerDetail(this.$route.query.customerId).then(res => {
                this.form.customerId = res.data.id;
                this.form.name = res.data.name;
                this.form.phone = res.data.phone;
            });
        },
        //房源下定
        getHouseDetail() {
            requestHouseDetailId(this.$route.query.houseId)
                .then(res => {
                    this.houseNow = res.data;
                    this.form.houseId = res.data.id;
                    this.form.address = res.data.address;
                    this.form.type = "1";
                    requestHouseType(this.houseNow.id, 1).then(resData => {
                        this.rentTypeList = resData.data;
                        this.rentTypeNow = this.$route.query.roomNo;
                        let rentTypeNow = this.rentTypeList.find(d => {
                            return d.roomNo == this.rentTypeNow;
                        });
                        this.hasDBJ = rentTypeNow.existCleanRoom;
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        },
        //搜索客户
        onSearchCustomer() {
            if (!this.searchValueCustomer) return;
            this.searchLoad = true;
            this.customerList = [];
            requestDesCustomerList({
                phone: this.searchValueCustomer,
                origin: "crm"
            }).then(res => {
                this.searchLoad = false;
                this.customerList = res.data;
            });
        },
        //选择客户
        changeCustomer(customer) {
            this.form.customerId = customer.id;
            this.form.name = customer.name;
            this.form.phone = customer.phone;
            this.showCustomer = false;
        },
        //搜索房源
        onSearchHouse() {
            if (!this.searchValueHouse) return;
            this.searchLoad = true;
            this.houseList = [];
            requestDesHouseList({ address: this.searchValueHouse }).then(
                res => {
                    this.searchLoad = false;
                    this.houseList = res.data;
                }
            );
        },
        //搜索取消
        onCancel() {
            this.showHouse = false;
            this.showCustomer = false;
        },
        //选择房源
        changeHouse(house) {
            requestHouseType(house.id, 1).then(res => {
                this.houseNow = house;
                this.form.houseId = house.id;
                this.form.address = house.address;
                this.form.type = "";
                this.showHouse = false;
                this.rentTypeList = res.data;
                this.rentTypeNow = "";
            });
        },
        //
        changeRentType(item) {
            if (item === "") return;
            let rentTypeNow = this.rentTypeList.find(d => {
                return d.roomNo == item;
            });
            this.hasDBJ = rentTypeNow.existCleanRoom;
            this.form.roomId = rentTypeNow.roomId;
            this.form.type = rentTypeNow.rentType;
            this.form.address = rentTypeNow.roomNo
                ? this.form.address + rentTypeNow.roomNo
                : this.form.address;
        },
        //日期确定
        orderDateConfirm(val) {
            console.log(formatDate(val));
            this.form.orderDate = formatDate(val) + " 00:00:00";
            this.showorderDate = false;
        },
        onSubmit() {
            console.log(this.form);
            if (!this.form.type) return;
            this.saveLoad = true;
            requestDestineContractAdd(this.form)
                .then(res => {
                    this.$toast.success({
                        message: "新增成功",
                        forbidClick: true,
                        onClose: () => {
                            this.$router.back();
                            // this.$router.push({ path: "destineList" });
                        }
                    });
                    this.saveLoad = false;
                })
                .catch(err => {
                    this.saveLoad = false;
                    console.log(err);
                });
        },
        //校验
        validPhone(val) {
            return validPhone(val);
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
/deep/.van-field__error-message {
    text-align: right;
}
.search {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    .van-search {
        /deep/i {
            line-height: 0.84rem;
        }
        /deep/input {
            border: none;
        }
    }
}
.field {
    background-color: #fff;
    border-bottom: 0.02667rem solid #ebedf0;
    .error {
        // position: absolute;
        padding: 0 0.42667rem 0.131rem 0;
        transform: translateY(-0.2rem);
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
